function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { createConsoleLogHandler, LogLevel } from '@sky-uk-ott/core-video-sdk-js-logger';
import { InternalConfigProvider } from './config/internal-config-provider';
import { filterStreamsByCodecCompatibility, getPreferredCompatibleStreamPropertyGroup, prioritiseCompatibleStreamPropertyGroups } from './core/player/stream-capability-specification';
import { TestingOverrides } from './core/services/testing-overrides';
import { VideoPlatformIntegration } from './core/video-platform-integration/video-platform-integration';
import { sdkLogger } from './logger';
import { JsonUtils } from './utils/json-utils';
import { version } from './version';
import { AudioCodec } from './core/player/audio-format';
export var CoreVideoInternal = /*#__PURE__*/ function() {
    "use strict";
    function CoreVideoInternal() {
        _class_call_check(this, CoreVideoInternal);
    }
    _create_class(CoreVideoInternal, null, [
        {
            key: "config",
            get: function get() {
                this.throwIfCoreSdkNotInitialised();
                return this._config;
            }
        },
        {
            key: "configFailoverReason",
            get: function get() {
                this.throwIfCoreSdkNotInitialised();
                return this._configFailoverReason;
            }
        },
        {
            key: "bandwidthEstimator",
            get: function get() {
                var _this__config_default_performance, _this__config_default, _this__config;
                this.throwIfCoreSdkNotInitialised();
                return (_this__config = this._config) === null || _this__config === void 0 ? void 0 : (_this__config_default = _this__config.default) === null || _this__config_default === void 0 ? void 0 : (_this__config_default_performance = _this__config_default.performance) === null || _this__config_default_performance === void 0 ? void 0 : _this__config_default_performance.bandwidthEstimator;
            }
        },
        {
            key: "deviceInfo",
            get: function get() {
                this.throwIfDeviceNotInitialised();
                return this.device.deviceInfo;
            }
        },
        {
            key: "storage",
            get: function get() {
                this.throwIfDeviceNotInitialised();
                return this.device.storage;
            }
        },
        {
            key: "input",
            get: function get() {
                this.throwIfDeviceNotInitialised();
                return this.device.input;
            }
        },
        {
            key: "lifecycle",
            get: function get() {
                this.throwIfDeviceNotInitialised();
                return this.device.lifecycle;
            }
        },
        {
            key: "networkStatus",
            get: function get() {
                this.throwIfDeviceNotInitialised();
                return this.device.networkStatus;
            }
        },
        {
            key: "deeplink",
            get: function get() {
                this.throwIfDeviceNotInitialised();
                return this.device.deeplink;
            }
        },
        {
            key: "capabilities",
            get: function get() {
                this.throwIfDeviceNotInitialised();
                return this.device.capabilities;
            }
        },
        {
            key: "display",
            get: function get() {
                this.throwIfDeviceNotInitialised();
                return this.device.display;
            }
        },
        {
            key: "telemetry",
            get: function get() {
                this.throwIfDeviceNotInitialised();
                return this.device.telemetry;
            }
        },
        {
            key: "deviceType",
            get: function get() {
                this.throwIfDeviceNotInitialised();
                return this.device.type;
            }
        },
        {
            key: "advertising",
            get: function get() {
                this.throwIfDeviceNotInitialised();
                return this.device.advertising;
            }
        },
        {
            key: "version",
            get: function get() {
                return version;
            }
        },
        {
            key: "playerVersion",
            get: function get() {
                this.throwIfCoreSdkNotInitialised();
                return this.playerEngineFactory.playerVersion;
            }
        },
        {
            key: "playerCapabilities",
            get: function get() {
                this.throwIfCoreSdkNotInitialised();
                return this.playerEngineFactory.capabilities;
            }
        },
        {
            key: "getCompatibleStreamPropertyGroup",
            value: /**
     * @deprecated
     * Use getCompatibleStreamPropertyGroupForPlaybackType to get per playback type, this ensures all configs are correctly applied
     */ function getCompatibleStreamPropertyGroup(playbackType) {
                return playbackType !== undefined ? this.getCompatibleStreamPropertyGroupForPlaybackType(playbackType) : this._getCompatibleStreamPropertyGroupByKey('default');
            }
        },
        {
            key: "getCompatibleStreamPropertyGroupForPlaybackType",
            value: function getCompatibleStreamPropertyGroupForPlaybackType(playbackType) {
                return this._getCompatibleStreamPropertyGroupByKey(playbackType);
            }
        },
        {
            key: "_getCompatibleStreamPropertyGroupByKey",
            value: function _getCompatibleStreamPropertyGroupByKey(key) {
                if (TestingOverrides.compatibleStreamPropertyGroup) {
                    sdkLogger.warn('Overriding Compatible Stream Property Group with: ', JsonUtils.stringify(TestingOverrides.compatibleStreamPropertyGroup));
                    return TestingOverrides.compatibleStreamPropertyGroup;
                }
                if (this._memoizedStreamCapabilityGroups[key]) {
                    return this._memoizedStreamCapabilityGroups[key];
                } else {
                    var compatibleStreamPropertyGroup = this._getCompatibleStreamPropertyGroup(key);
                    this._memoizedStreamCapabilityGroups[key] = compatibleStreamPropertyGroup;
                    return compatibleStreamPropertyGroup;
                }
            }
        },
        {
            key: "_getCompatibleStreamPropertyGroup",
            value: function _getCompatibleStreamPropertyGroup(playbackType) {
                var _this_playerCapabilities, _this_playerEngineFactory;
                var compatibleStreamPropertyGroups = (_this_playerCapabilities = this.playerCapabilities) === null || _this_playerCapabilities === void 0 ? void 0 : _this_playerCapabilities.compatibleStreamPropertyGroups;
                if (!compatibleStreamPropertyGroups || compatibleStreamPropertyGroups.length === 0) {
                    return;
                }
                var configPerPlaybackType = InternalConfigProvider.getForPlaybackType(this.config, playbackType);
                var preferredStreamPropertyGroups = configPerPlaybackType === null || configPerPlaybackType === void 0 ? void 0 : configPerPlaybackType.preferredStreamPropertyGroups;
                var preferredCompatibleGroups = compatibleStreamPropertyGroups;
                if (preferredStreamPropertyGroups && preferredStreamPropertyGroups.length > 0 && compatibleStreamPropertyGroups.length > 0) {
                    preferredCompatibleGroups = preferredStreamPropertyGroups.reduce(function(arr, preferredGroup) {
                        var newGroups = compatibleStreamPropertyGroups.map(function(compatibleGroup) {
                            return {
                                maxVideoFormat: Math.min(preferredGroup.maxVideoFormat, compatibleGroup.maxVideoFormat),
                                maxFrameRate: Math.min(preferredGroup.maxFrameRate, compatibleGroup.maxFrameRate),
                                supportedColourSpaces: preferredGroup.supportedColourSpaces.filter(function(colourSpace) {
                                    return compatibleGroup.supportedColourSpaces.includes(colourSpace);
                                })
                            };
                        });
                        return _to_consumable_array(arr).concat(_to_consumable_array(newGroups));
                    }, []);
                }
                var propositionSpecifications = this.propositionExtensions.streamCapabilitySpecifications;
                var streamSpecifications = playbackType && (propositionSpecifications === null || propositionSpecifications === void 0 ? void 0 : propositionSpecifications[playbackType]) || (propositionSpecifications === null || propositionSpecifications === void 0 ? void 0 : propositionSpecifications.default) || [];
                if ((_this_playerEngineFactory = this.playerEngineFactory) === null || _this_playerEngineFactory === void 0 ? void 0 : _this_playerEngineFactory.canSupportCodec) {
                    streamSpecifications = filterStreamsByCodecCompatibility(this.playerEngineFactory.canSupportCodec.bind(this.playerEngineFactory), streamSpecifications);
                }
                var preferredCapabilities = getPreferredCompatibleStreamPropertyGroup(preferredCompatibleGroups, streamSpecifications);
                if (preferredCapabilities) {
                    return preferredCapabilities;
                }
                var prioritisedCompatibleGroups = prioritiseCompatibleStreamPropertyGroups(preferredCompatibleGroups);
                return prioritisedCompatibleGroups[0];
            }
        },
        {
            key: "getAllowedAudioCodecs",
            value: function getAllowedAudioCodecs(supportedAudioCodecs, playbackType) {
                var allowedAudioCodecs = InternalConfigProvider.getForPlaybackType(this.config, playbackType || 'default').allowedAudioCodecs;
                return (allowedAudioCodecs === null || allowedAudioCodecs === void 0 ? void 0 : allowedAudioCodecs.join(',')) || (supportedAudioCodecs === null || supportedAudioCodecs === void 0 ? void 0 : supportedAudioCodecs.join(',')) || AudioCodec.MP4A2;
            }
        },
        {
            key: "playerType",
            get: function get() {
                this.throwIfCoreSdkNotInitialised();
                return this.playerEngineFactory.type;
            }
        },
        {
            key: "deviceAdsId",
            get: function get() {
                var _this_device_advertising;
                this.throwIfDeviceNotInitialised();
                return (_this_device_advertising = this.device.advertising) === null || _this_device_advertising === void 0 ? void 0 : _this_device_advertising.deviceAdsId();
            }
        },
        {
            key: "registerLogHandler",
            value: /**
     * Register a log handler to receive all framework logging information.
     * If a log handler is being set, it should be set before calling any other framework functions.
     * @param logHandler if no log handler is passed in, it defaults to a console logger set to the highest level of verbosity.
     */ function registerLogHandler() {
                var logHandler = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : createConsoleLogHandler(LogLevel.Verbose);
                sdkLogger.addLogger(logHandler);
            }
        },
        {
            key: "getSupportedStreamingProtocols",
            value: function getSupportedStreamingProtocols() {
                this.throwIfCoreSdkNotInitialised();
                return this.playerEngineFactory.getSupportedStreamingProtocols();
            }
        },
        {
            key: "getCurrentPlayerTypeForPlayoutData",
            value: function getCurrentPlayerTypeForPlayoutData(playoutData) {
                var _this_playerEngineFactory_getCurrentPlayerForPlayoutData, _this_playerEngineFactory;
                this.throwIfCoreSdkNotInitialised();
                return ((_this_playerEngineFactory_getCurrentPlayerForPlayoutData = (_this_playerEngineFactory = this.playerEngineFactory).getCurrentPlayerForPlayoutData) === null || _this_playerEngineFactory_getCurrentPlayerForPlayoutData === void 0 ? void 0 : _this_playerEngineFactory_getCurrentPlayerForPlayoutData.call(_this_playerEngineFactory, playoutData)) || this.playerEngineFactory.type;
            }
        },
        {
            key: "getPropositionExtensions",
            value: function getPropositionExtensions() {
                this.throwIfCoreSdkNotInitialised();
                return this.propositionExtensions;
            }
        },
        {
            key: "getCoreVideoConfigMetadata",
            value: function getCoreVideoConfigMetadata(playbackType) {
                this.throwIfCoreSdkNotInitialised();
                if (playbackType) {
                    var _this_config_playbackType;
                    return ((_this_config_playbackType = this.config[playbackType]) === null || _this_config_playbackType === void 0 ? void 0 : _this_config_playbackType.configMetadata) || this.config.default.configMetadata;
                }
                return this.config.default.configMetadata;
            }
        },
        {
            key: "getPlayerEngine",
            value: function getPlayerEngine(playerEngineOptions) {
                this.throwIfCoreSdkNotInitialised();
                if (!this.videoPlatformIntegration) {
                    throw new Error('Video platform integration provider not registered');
                }
                if (!this.playerEngineFactory) {
                    throw new Error('Player engine factory not registered');
                }
                return this.playerEngineFactory.createPlayerEngine(playerEngineOptions);
            }
        },
        {
            key: "getPlayerPrecursorEngine",
            value: function getPlayerPrecursorEngine() {
                if (this.playerEngineFactory.capabilities.hasPrefetchSupport) {
                    var _this_playerEngineFactory_createPlayerPrecursorEngine, _this_playerEngineFactory;
                    return (_this_playerEngineFactory_createPlayerPrecursorEngine = (_this_playerEngineFactory = this.playerEngineFactory).createPlayerPrecursorEngine) === null || _this_playerEngineFactory_createPlayerPrecursorEngine === void 0 ? void 0 : _this_playerEngineFactory_createPlayerPrecursorEngine.call(_this_playerEngineFactory);
                }
                return undefined;
            }
        },
        {
            key: "register",
            value: function register(config, configProvider, videoPlatformIntegrationProvider, device, playerEngineFactory, propositionExtensions, hdcpManager) {
                this._config = config;
                this.configProvider = configProvider;
                this.registerPropositionExtensions(propositionExtensions);
                this.registerVideoPlatformIntegration(videoPlatformIntegrationProvider, config, hdcpManager);
                this.device = device;
                this.registerPlayerEngineFactory(playerEngineFactory);
            }
        },
        {
            key: "reRegister",
            value: function reRegister(config, playerEngineFactory) {
                var _this = this;
                return _async_to_generator(function() {
                    var loaderPromises;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this._memoizedStreamCapabilityGroups = {};
                                _this._config = config;
                                loaderPromises = _this.propositionExtensions.addonLoaders.map(function(loader) {
                                    return loader.load(config);
                                });
                                return [
                                    4,
                                    Promise.all(loaderPromises)
                                ];
                            case 1:
                                _state.sent();
                                _this.registerPlayerEngineFactory(playerEngineFactory);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "throwIfCoreSdkNotInitialised",
            value: function throwIfCoreSdkNotInitialised() {
                if (!this._isInitialised) {
                    throw new Error('Core SDK is not initialised');
                }
            }
        },
        {
            key: "throwIfDeviceNotInitialised",
            value: function throwIfDeviceNotInitialised() {
                if (!this.device) {
                    throw new Error('Device is not initialised, call either loadDevice or initialise first');
                }
            }
        },
        {
            key: "registerPropositionExtensions",
            value: function registerPropositionExtensions(extensions) {
                this.propositionExtensions = extensions;
            }
        },
        {
            key: "registerPlayerEngineFactory",
            value: function registerPlayerEngineFactory(playerEngineFactory) {
                this.playerEngineFactory = playerEngineFactory;
            }
        },
        {
            key: "registerVideoPlatformIntegration",
            value: function registerVideoPlatformIntegration(videoPlatformIntegrationProvider, config, hdcpManager) {
                if (!videoPlatformIntegrationProvider) {
                    throw new Error('No VPIP was provided');
                }
                this.videoPlatformIntegration = new VideoPlatformIntegration(videoPlatformIntegrationProvider, this.coreVideoInternalWrapper, config, hdcpManager);
            }
        }
    ]);
    return CoreVideoInternal;
}();
_define_property(CoreVideoInternal, "sdkName", 'core-video-sdk-js');
_define_property(CoreVideoInternal, "device", void 0);
_define_property(CoreVideoInternal, "_isInitialised", null);
_define_property(CoreVideoInternal, "playerEngineFactory", void 0);
_define_property(CoreVideoInternal, "videoPlatformIntegration", void 0);
_define_property(CoreVideoInternal, "configProvider", void 0);
_define_property(CoreVideoInternal, "_configFailoverReason", void 0);
_define_property(CoreVideoInternal, "_config", void 0);
_define_property(CoreVideoInternal, "propositionExtensions", void 0);
_define_property(CoreVideoInternal, "_memoizedStreamCapabilityGroups", {});
_define_property(CoreVideoInternal, "coreVideoInternalWrapper", {
    config: function() {
        return CoreVideoInternal._config;
    },
    display: function() {
        return CoreVideoInternal.display;
    },
    getCompatibleStreamPropertyGroup: function(playbackType) {
        return CoreVideoInternal.getCompatibleStreamPropertyGroup(playbackType);
    },
    getCompatibleStreamPropertyGroupForPlaybackType: function(playbackType) {
        return CoreVideoInternal.getCompatibleStreamPropertyGroupForPlaybackType(playbackType);
    },
    capabilities: function() {
        return CoreVideoInternal.capabilities;
    },
    getPropositionExtensions: function() {
        return CoreVideoInternal.propositionExtensions;
    },
    deviceType: function() {
        return CoreVideoInternal.deviceType;
    },
    playerCapabilities: function() {
        return CoreVideoInternal.playerCapabilities;
    },
    getAllowedAudioCodecs: function(supportedAudioCodecs, playbackType) {
        return CoreVideoInternal.getAllowedAudioCodecs(supportedAudioCodecs, playbackType);
    }
});

//# sourceMappingURL=core-video-internal.js.map